import { Roles as Role } from '../../utils/enums'
import { getUserRole } from '../auth'
import { Roles } from './response'

export const listRoles = [
  {
    "id": Role.ADMIN,
    "description": "Administrador"
  },
  {
    "id": Role.GERENT,
    "description": "Gerente"
  },
  {
    "id": Role.SUPERVISOR,
    "description": "Supervisor"
  },
  {
    "id": Role.AGENT,
    "description": "Agente"
  },
  {
    "id": Role.SUPPORT,
    "description": "Soporte"
  },
  {
    "id": Role.AUDIT,
    "description": "Auditor"
  },
  {
    "id": Role.STORE,
    "description": "Tienda"
  },
  {
    "id": Role.PARTNER,
    "description": "Colaborador"
  }
]
export const RolesService = () => ({
  rolseList: async (payload?: { all: boolean }): Promise<Roles> => {
    const role = getUserRole()
    const roles = listRoles
    if (payload?.all) { return {roles} }
    switch (role) {
      case Role.GERENT:
        return { roles: (roles as Roles['roles']).filter((item) => ![Role.ADMIN, Role.GERENT].includes(item.id)) }
      case Role.SUPERVISOR:
        return { roles: (roles as Roles['roles']).filter((item) => ![Role.ADMIN, Role.GERENT, Role.SUPERVISOR].includes(item.id)) }
      case Role.AGENT:
      case Role.SUPPORT:
      case Role.AUDIT:
        return { roles: (roles as Roles['roles']).filter((item) => ![Role.ADMIN, Role.GERENT, Role.SUPERVISOR, Role.AGENT, Role.SUPPORT, Role.AUDIT].includes(item.id)) }
      case Role.STORE:
        return { roles: (roles as Roles['roles']).filter((item) => ![Role.ADMIN, Role.GERENT, Role.SUPERVISOR, Role.AGENT, Role.SUPPORT, Role.AUDIT, Role.STORE].includes(item.id)) }
      case Role.PARTNER:
        return {
          roles: [{
            id: Role.PARTNER,
            "description": "Colaborador"
          }]
        }
      default:
        return { roles }
    }
  },
})
